import RecruiterServices from "../../services/RecruiterServices";
import LoaderUtils from "../../utils/BaseUtils/LoaderUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import RouterUtils from "../../utils/BaseUtils/RouterUtils";

const recruiterService = new RecruiterServices();

export const state = {
  addCompanySuccess: false,
  editCompanySuccess: false,
  details: {},
  jobs: [],
  currentJobId: null,
  currentJob: {},
  jobApplicant: {},
  jobApplicants: [],
  jobInterviews: [],
  makeOfferSuccess: false,
  offers: [],
  changePasswordSuccess: false,
  updateJobStatusSuccess: false
};

export const namespaced = true;

export const getters = {
  getAddCompanySuccess: state => state.addCompanySuccess,
  getEditCompanySuccess: state => state.editCompanySuccess,
  getRecruiterDetails: state => state.details,
  getRecruiterJobs: state => state.jobs,
  getCurrentJobId: state => state.currentJobId,
  getCurrentJob: state => state.currentJob,
  getJobApplicants: state => state.jobApplicants,
  getJobApplicant: state => state.jobApplicant,
  getJobInterviews: state => state.jobInterviews,
  getOffers: state => state.offers,
  getMakeOfferSuccess: state => state.makeOfferSuccess,
  getChangePasswordSuccess: state => state.changePasswordSuccess,
  getUpdateJobStatusSuccess: state => state.updateJobStatusSuccess
};

export const mutations = {
  SET_ADD_COMPANY_SUCCESS(state, payload) {
    state.addCompanySuccess = payload;
  },
  SET_EDIT_COMPANY_SUCCESS(state, payload) {
    state.editCompanySuccess = payload;
  },
  SET_RECRUITER_DETAILS(state, payload) {
    state.details = payload;
  },
  SET_RECRUITER_JOBS(state, payload) {
    state.jobs = payload;
  },
  SET_CURRENT_JOB_ID(state, payload) {
    state.currentJobId = payload;
  },
  SET_CURRENT_JOB(state, payload) {
    state.currentJob = payload;
  },
  SET_JOB_APPLICANTS(state, payload) {
    state.jobApplicants = payload;
  },
  SET_JOB_APPLICANT(state, payload) {
    state.jobApplicant = payload;
  },
  SET_JOB_INTERVIEWS(state, payload) {
    state.jobInterviews = payload;
  },
  SET_MAKE_OFFER_SUCCESS(state, payload) {
    state.makeOfferSuccess = payload;
  },
  SET_CHANGE_PASSWORD_SUCCESS(state, payload) {
    state.changePasswordSuccess = payload;
  },
  SET_UPDATE_JOB_STATUS_SUCCESS(state, payload) {
    state.updateJobStatusSuccess = payload;
  },
  SET_OFFERS(state, payload) {
    state.offers = payload;
  }
};

export const actions = {
  editCompany() {
    let payload = {
      ...StoreUtils.rootGetters(StoreUtils.getters.form.GET_FORM_BODY),
      userid: StoreUtils.rootGetters(
        StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
      ).organizationid
    };

    let successAction = () => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_EDIT_COMPANY_SUCCESS,
        true
      );
      StoreUtils.dispatch(
        StoreUtils.actions.auth.APPLICANT_REFRESH_NON_BLOCKING
      );
      StoreUtils.dispatch("form/resetForm");
    };

    recruiterService.editCompany(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  addCompany() {
    let payload = {
      ...StoreUtils.rootGetters(StoreUtils.getters.form.GET_FORM_BODY),
      userid: StoreUtils.rootGetters(
        StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
      ).id
    };

    let successAction = () => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_ADD_COMPANY_SUCCESS,
        true
      );
      StoreUtils.dispatch(
        StoreUtils.actions.auth.APPLICANT_REFRESH_NON_BLOCKING
      );
      StoreUtils.dispatch("form/resetForm");
    };

    recruiterService.addCompany(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchJobs() {
    let payload = {
      recruiterid: StoreUtils.rootGetters(
        StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
      ).organizationid
    };

    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_RECRUITER_JOBS,
        responseData.data
      );
    };

    recruiterService.fetchJobs(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchSingleJob() {
    let payload = {
      jobid: StoreUtils.rootGetters(
        StoreUtils.getters.recruiter.GET_CURRENT_JOB_ID
      )
    };

    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_CURRENT_JOB,
        responseData.details
      );
    };

    recruiterService.fetchSingleJob(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  },
  updateJobStatus(_, status) {
    let payload = {
      status,
      jobid: StoreUtils.rootGetters(
        StoreUtils.getters.recruiter.GET_CURRENT_JOB_ID
      )
    };

    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_UPDATE_JOB_STATUS_SUCCESS,
        true
      );
    };

    recruiterService.updateJobStatus(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  updateJob() {
    let payload = {
      jobid: StoreUtils.rootGetters(
        StoreUtils.getters.recruiter.GET_CURRENT_JOB_ID
      )
    };

    let successAction = responseData => {
      StoreUtils.dispatch(StoreUtils.actions.recruiter.FETCH_SINGLE_JOB);
    };

    recruiterService.updateJob(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchJobApplicants(_, jobid) {
    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_JOB_APPLICANTS,
        responseData.data
      );
    };

    recruiterService.fetchJobApplicants(
      { jobid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchJobApplicant(_, applicantid) {
    let successAction = responseData => {
      StoreUtils.commit("applicant/SET_APPLICANT_INFO", responseData.details);
    };

    recruiterService.fetchJobApplicant(
      { applicantid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchJobInterviews(_, jobid) {
    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_JOB_INTERVIEWS,
        responseData.data
      );
    };

    recruiterService.fetchJobInterviews(
      { jobid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  inviteToInterview(_, payload) {
    let successAction = responseData => {
      RouterUtils.changeRouteUrlTo(`/job-post-interviews/${payload.jobid}`);
    };

    recruiterService.inviteToInterview(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  makeOffer(_, payload) {
    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_MAKE_OFFER_SUCCESS,
        true
      );
    };

    recruiterService.makeOffer(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchOffers() {
    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_OFFERS,
        responseData.data
      );
    };

    const payload = {
      recruiterid: StoreUtils.rootGetters(
        StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
      ).organizationid
    };

    recruiterService.fetchOffers(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  editJobPost(_, jobid) {
    let successAction = responseData => {
      StoreUtils.dispatch(StoreUtils.actions.recruiter.FETCH_SINGLE_JOB);
      RouterUtils.changeRouteUrlTo(`/recruiter-job-post/${jobid}`);
      StoreUtils.dispatch("form/resetForm");
    };

    recruiterService.editJobPost(
      {
        jobid,
        recruiterid: StoreUtils.rootGetters(
          StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
        ).organizationid,
        status: "new",
        ...StoreUtils.rootGetters(StoreUtils.getters.form.GET_FORM_BODY)
      },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  changePassword(_, payload) {
    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.recruiter.SET_CHANGE_PASSWORD_SUCCESS,
        true
      );
    };

    recruiterService.changePassword(
      {
        ...payload,
        userid:
          StoreUtils.rootGetters(
            StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
          ).userid ||
          StoreUtils.rootGetters(StoreUtils.getters.applicant.GET_APPLICANT_ID)
      },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
